// Loads the Google Maps JavaScript API once. Returns a cached promise.
// After it resolves, `google.maps.importLibrary(...)` is available.
let sdkPromise = null;

export function loadMapsSdk(apiKey) {
  if (window.google?.maps?.importLibrary) return Promise.resolve();
  if (sdkPromise) return sdkPromise;

  sdkPromise = new Promise((resolve, reject) => {
    try {
      const params = { key: apiKey, v: 'weekly', language: 'ja' };
      ((g) => {
        let h, a, k;
        const p = 'The Google Maps JavaScript API';
        const c = 'google';
        const l = 'importLibrary';
        const q = '__ib__';
        const m = document;
        const b = window[c] || (window[c] = {});
        const d = b.maps || (b.maps = {});
        const r = new Set();
        const u = () =>
          h ||
          (h = new Promise((f, n) => {
            a = m.createElement('script');
            const e = new URLSearchParams();
            e.set('libraries', [...r] + '');
            for (k in g) e.set(k.replace(/[A-Z]/g, (t) => '_' + t[0].toLowerCase()), g[k]);
            e.set('callback', c + '.maps.' + q);
            a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
            d[q] = f;
            a.onerror = () => {
              h = null;
              n(new Error(p + ' could not load.'));
            };
            a.nonce = m.querySelector('script[nonce]')?.nonce || '';
            m.head.append(a);
          }));
        if (d[l]) {
          console.warn(p + ' only loads once. Ignoring:', g);
        } else {
          d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n));
        }
      })(params);
      resolve();
    } catch (e) {
      reject(e);
    }
  });
  return sdkPromise;
}
